import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { useUser } from '../../context/user';
import { DELETE, GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { BILL_TYPE } from '../../utils/Utils';
import TransactionHistoryPreviewUpdate from './TransactionHistoryPreviewUpdate';


const TransactionHistoryPreviewUpdateManager = () => {
  const [data, setData] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [checkData, setCheckData] = useState(null);
  const [updatedAt, setUpdatedAt] = useState();
  const [cancelId, setCancelId] = useState();

  const [view, setView] = useState({
    detail: false,
    cancel: false,
  });

  const {
    state: {
      user,
    },
  } = useUser();


  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const onFormCancel = () => {
    setView({ detail: false, cancel: false });
  };

  const resetData = () => {
    setCheckData(null);
    onFormCancel();
    setUpdatedAt(moment().valueOf());
  };

  const colTable = [
    {
      Header: "Mã",
      accessor: "transactionHistoryId",
    },
    {
      Header: "Nội dung",
      accessor: (item) => item?.data?.content || "",
    },
    {
      Header: "Ngày",
      accessor: (item) => moment(item?.data?.date, 'YYYY-MM-DD').format('DD-MM-YYYY'),
    },
    {
      Header: "Loại",
      accessor: (item) => BILL_TYPE[item?.data?.type],
    },
    {
      Header: "Lý do",
      accessor: (item) => item?.reason,
    },
    {
      Header: "Người y/c",
      accessor: (item) => item?.createdUser?.name,
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setCheckData(item)
                        toggle('detail');
                      }}
                    >
                      <Icon
                        name={"eye"}
                      ></Icon>
                      <span>
                        Xem
                      </span>
                    </DropdownItem>
                  </li>
                  {
                    user?.id === item.createdBy ? <li>
                      <DropdownItem
                        tag="a"
                        href="#dropdown"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setCancelId(item.transactionHistoryId);
                          toggle("cancel");
                        }}
                      >
                        <Icon name="trash" className="text-danger"></Icon>
                        <span>Huỷ</span>
                      </DropdownItem>
                    </li> : null
                  }
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    getData();
  }, [updatedAt]);

  const getData = () => {
    setLoading(true);
    setData([]);

    GET(`/transaction-history/list-request-update`, {}, true)
      .then(({ data }) => {
        setData([...data]);

      })
      .finally(() => {
        setLoading(false);
      });

  };

  const cancelRequestUpdate = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/transaction-history/cancel-request-update/${id}`, {}, true)
      .then((res) => {
        toast.success("Huỷ thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  return (
    <React.Fragment>
      <Head title="Quản lý đơn hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Danh sách thu chi cần duyệt</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    notShowPagi
                    loading={loading}
                    columns={colTable}
                    data={data}

                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
        {view.detail ? <Modal style={{ width: '80vw', maxWidth: '80vw' }} isOpen={true} toggle={() => onFormCancel()}>
          <ModalBody>
            <div className="nk-modal">
              <TransactionHistoryPreviewUpdate data={checkData} onSuccess={resetData} />
            </div>
          </ModalBody>
        </Modal> : <></>}

        <Modal isOpen={view.cancel} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn huỷ yêu cầu này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    cancelRequestUpdate(cancelId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default TransactionHistoryPreviewUpdateManager;
